import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../context';
import ClearFiltersButton from './ClearFiltersButton';
import ConversionList from './ConversionList';
import FilterButton from './FilterButton';
import PartnerOfferingsFilterSelect from './PartnerOfferingsFilterSelect';

const DashboardConversionActivity = (props) => {
    const dispatch = useDispatch();
    const {
        filterTrial,
        filterFinal,
        filterPastDue,
        filterOneWeek,
        filterLater,
        filterComplete,
    } = useSelector((state) => ({
        filterTrial: state.conversions.filterTrial,
        filterFinal: state.conversions.filterFinal,
        filterPastDue: state.conversions.filterPastDue,
        filterOneWeek: state.conversions.filterOneWeek,
        filterLater: state.conversions.filterLater,
        filterComplete: state.conversions.filterComplete,
    }), shallowEqual);

    const [filterPartner, setFilterPartner] = useState('');

    const clearFilters = () => {
        setFilterPartner('');
        dispatch(actions.conversions.clearConversionActivityFilters());
    };

    const setFilterTrial = () => {
        dispatch(actions.conversions.setTrialFilter(!filterTrial));
        dispatch(actions.conversions.setFinalFilter(false));
    };

    const setFilterFinal = () => {
        dispatch(actions.conversions.setTrialFilter(false));
        dispatch(actions.conversions.setFinalFilter(!filterFinal));
    };

    const setFilterPastDue = () => {
        dispatch(actions.conversions.setPastDueFilter(!filterPastDue));
        dispatch(actions.conversions.setOneWeekFilter(false));
        dispatch(actions.conversions.setLaterFilter(false));
        dispatch(actions.conversions.setCompleteFilter(false));
    };

    const setFilterOneWeek = () => {
        dispatch(actions.conversions.setPastDueFilter(false));
        dispatch(actions.conversions.setOneWeekFilter(!filterOneWeek));
        dispatch(actions.conversions.setLaterFilter(false));
        dispatch(actions.conversions.setCompleteFilter(false));
    };

    const setFilterLater = () => {
        dispatch(actions.conversions.setPastDueFilter(false));
        dispatch(actions.conversions.setOneWeekFilter(false));
        dispatch(actions.conversions.setLaterFilter(!filterLater));
        dispatch(actions.conversions.setCompleteFilter(false));
    };

    const setFilterComplete = () => {
        dispatch(actions.conversions.setPastDueFilter(false));
        dispatch(actions.conversions.setOneWeekFilter(false));
        dispatch(actions.conversions.setLaterFilter(false));
        dispatch(actions.conversions.setCompleteFilter(!filterComplete));
    };
    
    let hasFilter = filterTrial || filterFinal || filterPastDue || filterComplete;
    hasFilter = hasFilter || filterOneWeek || filterComplete || filterLater;
    hasFilter = hasFilter || filterPartner !== '';

    return (
        <div className="px-3 pt-3 pb-1 sc-glass shadow sc-rounded">
            <div className="w-100 d-flex flex-wrap justify-content-between">
                <h2>Conversion Activity</h2>
            </div>
            {/* TODO: looks bad on small screens, needs better styling */}
            <div className="d-flex justify-content unselectable"
                style={{ justifyContent: 'space-around' }}>
                <span className="text-nowrap my-1 p-1">
                    <FontAwesomeIcon icon={faFilter} size="lg" />
                </span>
                &nbsp;
                <FilterButton callback={setFilterTrial} isActive={filterTrial} text='Trial' />
                &nbsp;
                <FilterButton callback={setFilterFinal} isActive={filterFinal} text='Final' />
                &nbsp;
                <FilterButton callback={setFilterPastDue} isActive={filterPastDue} text='Past Due' color='bg-danger' />
                &nbsp;
                <FilterButton callback={setFilterOneWeek} isActive={filterOneWeek} text='This Week' color='bg-warning' />
                &nbsp;
                <FilterButton callback={setFilterLater} isActive={filterLater} text='Upcoming' color='bg-primary' />
                &nbsp;
                <FilterButton callback={setFilterComplete} isActive={filterComplete} text='Complete' color='bg-success' />
            </div>

            <div className="py-2 pl-4 mb-2 border-bottom d-flex justify-content-between unselectable">
                <PartnerOfferingsFilterSelect filterPartner={filterPartner} setFilterPartner={setFilterPartner} />
                {hasFilter && <ClearFiltersButton clearFilters={clearFilters}/>}
            </div>
            <ConversionList filterPartner={filterPartner} />
        </div>
    );
};

export default DashboardConversionActivity;
